import * as React from 'react';
import { makeStyles, SnackbarContent, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-duotone-svg-icons/faExclamationCircle';
import * as Dtos from '../api/dtos';

interface IErrorViewProps {
    title: string;
    message?: string;
    responseStatus?: Dtos.ResponseStatus;
}

const useStyles = makeStyles(theme => ({
    error: {
        backgroundColor: theme.palette.error.dark,
        overflow: 'auto'
    },
    message: {
        display: 'flex',
        alignItems: 'flex-start',
    },
    messageIcon: {
        marginRight: theme.spacing(4)
    },
    messageSpacing: {
        marginTop: theme.spacing(3)
    }
}))

const ErrorView: React.FunctionComponent<IErrorViewProps> = ({
    responseStatus,
    message,
    title
}) => {
    const classes = useStyles();

    if (!responseStatus && !title) {
        return null;
    }

    return (
        <SnackbarContent
            className={classes.error}
            message={
                <span className={classes.message}>
                    <FontAwesomeIcon className={classes.messageIcon} size="2x" icon={faExclamationCircle} fixedWidth />
                    <div>
                        {
                            !!title && (
                                <Typography variant="h3">
                                    {title}
                                </Typography>
                            )
                        }
                        {
                            !!message && (
                                <div className={classes.messageSpacing} >
                                    <Typography>
                                        {message}
                                    </Typography>
                                </div>
                            )
                        }
                        {
                            !!responseStatus && (
                                <div className={classes.messageSpacing} >
                                    {
                                        !!responseStatus.message && (
                                            <pre>
                                                {
                                                    !!responseStatus.errorCode && (
                                                        `${responseStatus.errorCode}\t`
                                                    )
                                                }{responseStatus.message}
                                            </pre>
                                        )
                                    }
                                    {
                                        !!responseStatus.stackTrace && (
                                            <pre>
                                                {responseStatus.stackTrace}
                                            </pre>
                                        )
                                    }
                                    {
                                        !!responseStatus.errors && (
                                            responseStatus.errors.map((error, index) => {
                                                return (
                                                    <div key={index} className={classes.messageSpacing} >
                                                        {
                                                            !!error.fieldName && (
                                                                <strong>
                                                                    {error.fieldName}
                                                                </strong>
                                                            )
                                                        }
                                                        {
                                                            !!error.message && (
                                                                <pre>
                                                                    {
                                                                        !!error.errorCode && (
                                                                            `${error.errorCode}\t`
                                                                        )
                                                                    }{error.message}
                                                                </pre>
                                                            )
                                                        }
                                                        {
                                                            !!error.meta && !!error.meta.detail && (
                                                                <pre>
                                                                    {error.meta.detail}
                                                                </pre>
                                                            )
                                                        }
                                                    </div>
                                                );
                                            })
                                        )
                                    }
                                </div>
                            )
                        }
                    </div>
                </span>
            }
        />
    );
}

export default ErrorView;


// WEBPACK FOOTER //
// ./src/components/ErrorView.tsx